import { useCallback, useEffect } from 'react';
import { useSittJoyride } from '../../../shared/tours/useSittJoyride';
import { hasSeenTour } from '../../../shared/tours/tourStorage';
import { OT_GENERAL_TOUR_KEY, getOtStepTourSteps, otGeneralTourSteps } from '../tours/otStepperTours';

const AUTO_TOUR_DELAY_MS = 700;

export function useOtStepperTour(isLoadingInitial: boolean, activeStep: number) {
    const { Tour, runTour } = useSittJoyride({ storageKey: OT_GENERAL_TOUR_KEY });

    useEffect(() => {
        if (isLoadingInitial || hasSeenTour(OT_GENERAL_TOUR_KEY)) return;
        const timer = window.setTimeout(() => runTour(otGeneralTourSteps), AUTO_TOUR_DELAY_MS);
        return () => window.clearTimeout(timer);
    }, [isLoadingInitial, runTour]);

    const startGeneralTour = useCallback(() => {
        runTour(otGeneralTourSteps);
    }, [runTour]);

    const startStepTour = useCallback(() => {
        runTour(getOtStepTourSteps(activeStep));
    }, [activeStep, runTour]);

    return { Tour, startGeneralTour, startStepTour };
}
